<template>
    <div>
      <b-container fluid>
        <b-row>
          <b-col>
            <h3>Seleção de Operações</h3>
          </b-col>
        </b-row>

        <b-row align-h="between">
          <!-- Pesquisar -->
          <b-col cols="4">
            <b-form-group
              label-align="left"
              label-for="filterInput"
              label="Pesquisar operação:"
            >
              <b-input-group>
                <b-form-input
                  v-model="filter.name"
                  type="search"
                  id="filterInput"
                  size="sm"
                ></b-form-input>
                <b-input-group-append>
                  <b-button size="sm" :disabled="!filter.name" @click="filter.name = ''">Limpar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <!-- Status -->
          <b-col cols="3">
            <b-form-group label-align="left" label="Mostrando:">
              <b-form-radio-group buttons v-model="filter.status" >
                <b-form-radio class="mybtn" value="active,inactive">Todos</b-form-radio>
                <b-form-radio class="mybtn" value="active">Ativos</b-form-radio>
                <b-form-radio class="mybtn" value="inactive">Inativos</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>

          <!-- Tipo -->
          <b-col cols="3">
            <b-form-group label-align="left" label="Operação:">
              <b-form-radio-group buttons v-model="filter.type">
                <b-form-radio class="mybtn" value="evento,ficha">Todas</b-form-radio>
                <b-form-radio class="mybtn" value="evento">Evento</b-form-radio>
                <b-form-radio class="mybtn" value="ficha">Ficha</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-col cols="12" class="mt-1 mb-2">
            {{ localData.events.length === 0 ? 'Nenhuma operação selecionada' : localData.events.length === 1 ? '1 operação selecionada' : localData.events.length + ' operações selecionadas' }}

            <!-- Botão para alternar visualização -->
            <b-link @click="toggleSelectedEvents" class="ml-3">{{ showSelectedOnly ? 'Exibir Todos' : 'Exibir Selecionados' }}</b-link>

            <a href="#" @click.prevent="localData.events = []" class="ml-3">Limpar selecionados</a>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" class="mt-2 mb-3">
            <!-- Listagem de eventos -->
            <b-table striped hover show-empty
              :items="getEvents"
              :fields="fields"
              primary-key="id"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentPage"
              :per-page="perPage"
              empty-filtered-text="Nenhum evento encontrado"
              empty-text="Nenhum evento encontrado"
              ref="table"
              responsive
            >
              <!-- Coluna: Select -->
              <template v-slot:cell(select)="data">
                <b-form-checkbox v-model="localData.events" :value="data.item.id"></b-form-checkbox>
              </template>

              <!-- Coluna: Tipo -->
              <template v-slot:cell(event_type)="data">
                  <b-badge :class="data.item.type === 'evento' ? 'blue-1' : 'blue-2'">
                    {{ data.item.type | capitalize }}
                  </b-badge>
                </template>
            </b-table>
          </b-col>
        </b-row>

        <b-row>
          <!-- Paginação -->
          <b-col cols="5">

            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
            ></b-pagination>
          </b-col>

          <b-col cols="7" class="text-right">
            <b-button @click="emitPrevious" class="mr-1 px-3" variant="secondary">
              <icon name="arrow-left" scale="1" class="mr-2"></icon> Voltar
            </b-button>

            <b-button @click="emitData" class="mr-1 px-3" variant="success" :disabled="localData.events.length === 0">
              Avançar <icon name="arrow-right" scale="1" class="ml-2"></icon>
            </b-button>
          </b-col>

        </b-row>
      </b-container>
    </div>
</template>

<script>
export default {
  props: {
    // Determina se é edição ou criação
    isEdit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      search: '',
      fields: [
        { key: 'select', label: 'Selecionar', class: ['text-center', 'align-middle'], tdClass: 'w-100px' },
        { key: 'event_type', label: 'Operação', class: ['text-center', 'align-middle'], tdClass: 'w-100px' },
        { key: 'name', label: 'Nome', class: ['align-middle'] },
      ],
      filter: {
        name: '',
        status: 'active',
        type: 'evento,ficha',
        selectedIds: []
      },
      showSelectedOnly: this.isEdit ? true : false,
      filterOn: [],
      availableEvents: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      localData: {
        events: this.data.events || [], // Inicializa com os eventos selecionados
      },
    };
  },
  computed: {
    filteredEvents() {
      return this.availableEvents.filter(event =>
        event.name.toLowerCase().includes(this.search.toLowerCase())
      );
    }
  },
  async mounted() {
    await this.getEvents()
  },
  methods: {
    emitData() {
      this.$emit('update-data', this.localData);
      this.$emit('next'); // Avança para a próxima etapa
    },
    emitPrevious() {
      this.$emit('previous'); // Volta para a etapa anterior
    },
    async getEvents (ctx) {
      try {
        // Se estiver mostrando apenas selecionados, modifica a lógica
        if (this.showSelectedOnly && this.localData.events?.length) {
          let selectedIds = this.localData.events.join(',')
          // Adiciona os IDs selecionados como parâmetro na URL
          ctx.filter.selectedIds = selectedIds
        } else {
          this.filter.selectedIds = []
        }

        let order = ctx.sortDesc ? 'desc' : 'asc'
        let name = ctx.filter.name ? '&name=' + ctx.filter.name : ''
        let status = ctx.filter.status ? '&status=' + ctx.filter.status : ''
        let type = ctx.filter.type ? '&type=' + ctx.filter.type : ''
        let selectedFilter = ctx.filter.selectedIds ? '&ids=' + ctx.filter.selectedIds : ''

        let url = process.env.VUE_APP_URL_APP + '/b/events?page=' + ctx.currentPage + '&limit=' + ctx.perPage + '&sort=' + ctx.sortBy + '&order=' + order + name + status + type + selectedFilter

        const resp = await this.$http.get(url)

        this.currentPage = parseInt(resp.headers.get('x-page'))
        this.totalRows = parseInt(resp.headers.get('x-total-record'))
        this.perPage = parseInt(resp.headers.get('x-limit'))

        return resp.body
      } catch (error) {
        return []
      }
    },
    toggleSelectedEvents() {
        this.showSelectedOnly = !this.showSelectedOnly
        this.currentPage = 1 // Reset para primeira página
        this.filter.selectedIds = []
        this.$refs.table.refresh() // Força atualização da tabela
      }
  },
};
</script>

<style scoped>
.blue-1 {
  background-color: #1c4c6c;
}

.blue-2 {
  background-color: #63abcb;
}
.w-100px {
  width: 100px !important;
}
</style>
